import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Notifications, {notify} from 'react-notify-toast';
import InputMask from 'react-input-mask';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone';
import 'react-input-range/lib/css/index.css';


@inject('userStore')
class TeamForm extends Component{
    constructor(props){
        super(props);
    }

    render(){
        const CheckBox = props => {
            const checked = props.bus_user_role_id ? "checked" : null;
            return <input {...props} checked={checked}/>
        };
        const {user, handleInputChange, bus_user_list, bus_srv_list, serviceHandler, roleHandler, emailHandler} = this.props;
        return (
        <React.Fragment>
            <ul className="nav nav-tabs nav-tabs-danger nav-justified" role="tablist">
            {user.id !== 0 ?
              <React.Fragment>
                <li className="nav-item">
                    <a className="nav-link active" data-toggle="tab" href="#details" role="tab">Details</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#roles" role="tab">Roles</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#services" role="tab">Services</a>
                </li>
              </React.Fragment>
              : null
            }
            </ul>
            <div className="tab-content">
                <div className="tab-pane fade active show form-type-combine" id="details">
                    <div className="form-groups-attached">
                        <div className="row">
                            <div className="form-group col-6">
                                <label>First Name</label>
                                <input className="form-control" name="first_name" type="text" onChange={handleInputChange} value={user.first_name}/>
                            </div>
                            <div className="form-group col-6">
                                <label>Last Name</label>
                                <input className="form-control" name="last_name" type="text" onChange={handleInputChange} value={user.last_name}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-12">
                                <label>Phone</label>
                                <InputMask className="form-control" mask="(999)-999-9999" maskChar=" " name="phone_primary" value={user.phone_primary} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-12">
                                <label>Email</label>
                                <input className="form-control" name="email" type="text" onChange={handleInputChange} value={user.email}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-12">
                                <label>Calendar Link</label>
                                <input className="form-control" name="calendar_link" type="text" onChange={handleInputChange} value={user.calendar_link}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-12">
                                <label>Active Status</label>
                                <select className="form-control" name="sys_status_id"  value={user.sys_status_id} onChange={handleInputChange}>
                                {user.sys_status_list ?
                                  user.sys_status_list.map((status, index) =>
                                    <option key={index} value={status[0]}>{status[1]}</option>
                                  ):<option value="1">Active</option>}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-12">
                                <label>Receive Notification Emails</label>
                                <select className="form-control" name="email_cfg"  value={user.email_cfg} onChange={handleInputChange}>
                                  <option value={0}>No</option>
                                  <option value={1}>Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="roles">
                    <div className="switch-stacked">
                    {user.role_list.map((role, index) =>
                        <label className="switch switch-lg" key={index}>
                            <CheckBox type="checkbox" bus_user_role_id={role.bus_user_role_id} onChange={(event) => roleHandler(event, user, role)}/>
                            <span className="switch-indicator"></span>
                            <span className="switch-description">{role.name}</span>
                        </label>
                    )}
                    </div>
                </div>
                <div className="tab-pane fade" id="services">
                    <p className="hint">Choosing the services a team member performs helps you decide who to assign to an event.</p>
                    <div className="switch-stacked">
                    {user.bus_srv_list.map((bus_srv, index) =>
                        <label className="switch switch-lg" key={index}>
                            <CheckBox type="checkbox" bus_user_role_id={bus_srv.user_id} onChange={(event) => serviceHandler(event, user, bus_srv)}/>
                            <span className="switch-indicator"></span>
                            <span className="switch-description">{bus_srv.name}</span>
                        </label>
                    )}
                    </div>
                </div>
            </div>
        </React.Fragment>
        );
    }
}


@inject('userStore')
class SettingsTeam extends Component {
    constructor(props){
        super(props);
        this.state = {
            business:null,
            quickviewVisible:false,
            selectedItem:null,
            component:null,
            bus_user_list:[],
            uploadVisible:false
        }
        this.closeQuickview = this.closeQuickview.bind(this);
        this.setSelected = this.setSelected.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
        this.roleOnChange = this.roleOnChange.bind(this)
        this.serviceOnChange = this.serviceOnChange.bind(this)
    }

    componentDidMount(){
        this.setState({
            business:this.props.business,
            bus_user_list:this.props.business.bus_user_list
        });
    }

    closeQuickview(){
        this.setState({quickviewVisible:false,selectedItem:null});
    }

    setSelected(item){
      if (item === null){
        item = {id:0,first_name:"",last_name:"",phone_primary:"",calendar_link:"",email:"",sys_status_id:1,role_list:[],bus_srv_list:[]}
      }
      this.setState({
        quickviewVisible:true,
        selectedItem:item
      });
    }

    handleInputChange(e) {
        let updatedSelectedItem = Object.assign({}, this.state.selectedItem);
        updatedSelectedItem[e.target.name] = e.target.value;
        this.setState({selectedItem:updatedSelectedItem});
    }

    roleOnChange(event, user, sys_role){
        var checked = 0
        if (event.target.checked){
            checked = 1;
        }
        // save this
        post('v2/save/bus_user_role', {
                bus_user_id: user.id,
                checked: checked,
                sys_role_id:sys_role.sys_role_id
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                    let index = this.state.bus_user_list.findIndex(x => x.id === user.id);
                    let temp_bus_user_list = Object.assign([], this.state.bus_user_list);
                    temp_bus_user_list[index] = res.data.bus_user;
                    this.setState({bus_user_list:temp_bus_user_list, selectedItem:res.data.bus_user});
                    notify.show(res.data.message, "success", 4000);
                } else {
                    notify.show(res.data.message, "error", 4000);
                }
          }).catch((error) => {
                console.log(error);
                return error;
          });
    }

    serviceOnChange(event, user, bus_srv){
        var checked = 0
        if (event.target.checked){
            checked = 1;
        }
        // save this
        post('v2/save/bus_user_srv', {
                bus_user_id: user.id,
                checked: checked,
                bus_srv_id:bus_srv.bus_srv_id
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                    let index = this.state.bus_user_list.findIndex(x => x.id === user.id);
                    let temp_bus_user_list = Object.assign([], this.state.bus_user_list);
                    temp_bus_user_list[index] = res.data.bus_user;
                    this.setState({bus_user_list:temp_bus_user_list, selectedItem:res.data.bus_user});
                    notify.show(res.data.message, "success", 4000);
                } else {
                    notify.show(res.data.message, "error", 4000);
                }
          }).catch((error) => {
                console.log(error);
                return error;
          });

    }

    saveUser(){
        post('/v2/save/bus_user', {item:this.state.selectedItem},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
              let temp_bus_user_list = Object.assign([], this.state.bus_user_list);
              if (res.data.mode === 'edit'){
                let index = this.state.bus_user_list.findIndex(x => x.id === this.state.selectedItem.id);
                temp_bus_user_list[index] = res.data.bus_user;
              } else {
                temp_bus_user_list.push(res.data.bus_user);
              }
              this.setState({bus_user_list:temp_bus_user_list, selectedItem:res.data.bus_user});
              notify.show(res.data.message, "success", 4000);
            } else {
                notify.show(res.data.message, "error", 4000);
            }
        }).catch((error) => {
            notify.show(error, "error", 4000);
            console.log(error);
            return error;
        });
    }

    resetPassword = () => {
        post('/v2/post/pw_reset', {hash_id:this.state.selectedItem.user_hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                notify.show(res.data.message, "success", 4000);
            } else {
                notify.show(res.data.message, "error", 4000);
            }
        }).catch((error) => {
            notify.show(error, "error", 4000);
            console.log(error);
            return error;
        });
    }

    fileUpload(){
        const formData = new FormData();
        formData.append('file',this.state.files[0])
        formData.append('id', this.state.selectedItem.user_id)
        formData.append('typeof', 'user')
        post('/v2/upload/media', formData,{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                // set the new thumb image
                let index = this.state.bus_user_list.findIndex(x => x.id === this.state.selectedItem.id);
                let temp_bus_user_list = Object.assign([], this.state.bus_user_list);
                let temp_bus_user = Object.assign([], this.state.selectedItem);
                temp_bus_user.thumb = res.data.src;
                temp_bus_user_list[index] = temp_bus_user;
                this.setState({
                    selectedItem:temp_bus_user,
                    bus_user_list:temp_bus_user_list,
                    uploadVisible:!this.state.uploadVisible
                })
                notify.show(res.data.message, "success", 4000);
            } else {
                notify.show(res.data.message, "error", 4000);
            }
        }).catch((error) => {
            notify.show("Error occurred", "error", 4000);
            console.log(error);
            return error;
        });
    }

    onDrop(files) {
        this.setState({
              files:files
          }, ()=>this.fileUpload());
      }

      onCancel() {
      }

    openUpload = () => {
        this.setState({
            uploadVisible:!this.state.uploadVisible
        })
    }


    render(){
        const dropzone = {
            'position': 'relative',
            'width': '200px',
            'height': '200px',
            'borderWidth': '2px',
            'borderColor': 'rgb(102, 102, 102)',
            'borderStyle': 'dashed',
            'borderRadius': '5px',
            marginTop: '15px',
            marginRight: 'auto',
            marginBottom: 0,
            marginLeft: 'auto',
        };

        if (!this.state.business) return <div className="alert alert-info">Loading...</div>;
        return (
        <React.Fragment>
        <Notifications/>
        <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
            {this.state.selectedItem ?
                <React.Fragment>
                    <header className="quickview-header">
                        <p className="quickview-title lead fw-400">{this.state.selectedItem.id !== 0 ? this.state.selectedItem.full_name : "Add Team Member"}</p>
                        <span className="close" onClick={this.closeQuickview}><i className="ti-close"></i></span>
                    </header>
                    <PerfectScrollbar>
                    <div className="quickview-body ps-container ps-theme-default">
                        <div className="card card-inverse mb-0">
                        {this.state.selectedItem.id !== 0 ?
                            <div className="card-body text-center pb-20 pt-20">
                                <img src={this.state.selectedItem.thumb} className="avatar avatar-xxl avatar-bordered" />
                                <br/>
                                {!this.state.selectedItem.locked ?
                                <React.Fragment>
                                  <button className="btn btn-sm btn-primary mt-15" onClick={this.openUpload}>{this.state.uploadVisible ? "Close" : "Upload New Thumb"}</button>
                                  <Dropzone
                                      multiple={false}
                                      onDrop={this.onDrop}
                                      className={this.state.uploadVisible ? "" : "d-none"}
                                      style={dropzone}
                                      onFileDialogCancel={this.onCancel}>
                                    <p>Drop a new image file here, or click to select file to upload.</p>
                                  </Dropzone>
                                </React.Fragment>
                                :null}
                            </div>
                          : null}
                        </div>
                        <div className="quickview-block">
                            <TeamForm user={this.state.selectedItem} handleInputChange={this.handleInputChange} bus_user_list={this.state.business.bus_user_list} serviceHandler={this.serviceOnChange} roleHandler={this.roleOnChange}/>
                            {this.state.selectedItem.locked ? <p className="text-info">Because this user is assigned to another business the account detail information can only be edited by them.  You can still assign them to roles and services.</p> : null}
                        </div>
                    </div>
                    </PerfectScrollbar>
                    <footer className="quickview-footer flex-row-reverse">
                      {!this.state.selectedItem.locked ?
                        <React.Fragment>
                        <button className="btn btn-primary" type="submit" onClick={this.saveUser}>Save</button>
                        {this.state.selectedItem.id !== 0 ? <button className="btn btn-info" type="submit" onClick={this.resetPassword}>Reset Password</button> : null}
                        </React.Fragment>
                        : null}
                        <button className="btn btn-secondary" type="button" onClick={this.closeQuickview}>Cancel</button>
                    </footer>
                </React.Fragment>
            : <div>Loading</div> }
        </div>
        <div className="card">
            <h4 className="card-header">
              Team Members
              <button className="btn btn-success pull-right" onClick={()=>this.setSelected(null, true)}><i className="fa fa-plus"></i> Add Team Member</button>
            </h4>
            <div className="media-list media-list-divided media-list-lg">
                {this.state.bus_user_list.map((bus_user, index)=>
                    <div key={index} className="media cursor-pointer" onClick={()=>this.setSelected(bus_user, true)}>
                        <span className={String(bus_user.sys_status_id) === "1" ? "avatar status-success" : "avatar status-danger"}>
                            <img src={bus_user.thumb} alt="..."/>
                        </span>
                        <div className="media-body">
                            <p><strong>{bus_user.first_name} {bus_user.last_name}</strong></p>
                            <div className="media-block-actions mt-0">
                                <nav className="nav nav-dot-separated">
                                    <a className="nav-link" href="#">{bus_user.phone_primary}</a>
                                    <a className="nav-link" href="#">{bus_user.email}</a>
                                </nav>
                            </div>
                            <span></span>
                        </div>
                    </div>
                )}
            </div>
        </div>
        </React.Fragment>
        );
    }
}

export default SettingsTeam;



// WEBPACK FOOTER //
// ./src/components/business/SettingsTeam.js